import { useContext, useState, useRef, useEffect } from "react";
import { Row, Col, Card, Container } from "react-bootstrap";

import {
  Titulo,
  Cargando,
  excepcionVacia,
  llamarApi,
  quitarCcParam,
  logger
} from "./Comun";

import Contexto from "./Contexto";

const ListaSedes = (props) => {
  const contextoApp = useContext(Contexto);

  const [isLoading, setIsLoading] = useState(true);

  const [resListaSedes, setResListaSedes] = useState(null);
  const [idSedeHover, setIdSedeHover] = useState(false);

  const fetchEjecutado = useRef(false);

  const handleChangeIdSede = (pIdSede) => {
    if (pIdSede) {
      quitarCcParam();

      props.setIdSede(pIdSede);

      if (contextoApp.empleadoSeleccionable === 1) {
        props.irAPAso("LE");
      } else {
        props.irAPAso("LTS");
      }
    }
  };

  const handleMouseEnter = (e) => {
    setIdSedeHover(e);
  };

  const handleMouseLeave = (e) => {
    setIdSedeHover(null);
  };

  useEffect(() => {
    if (fetchEjecutado.current) return;
    fetchEjecutado.current = true;

    if (resListaSedes === null) {
      const urlAPI = contextoApp.urlBaseApis + "ls";

      logger(
        new Date().getHours() +
          ":" +
          new Date().getMinutes() +
          "." +
          new Date().getSeconds() +
          "- Llamo a la api del lista sedes"
      );

      llamarApi({
        url: urlAPI,
        jwt: props.jwt,
        method: "GET",
        payload: { idCanalCaptacion: contextoApp.idCanalCaptacion },
        onSuccess: (data) => {
          props.setJwt(data.jwt);
          setResListaSedes(data.arraySedes);
          props.setExcepcion(excepcionVacia);
        },
        onError: (err) => props.setExcepcion(err),
        onFinally: () => setIsLoading(false),
      });
    } // No tengo que lanzar la api
    else {
      setIsLoading(false);
    }
  }, []);

  if (isLoading) return <Cargando mensaje="Cargando sedes ..."></Cargando>;

  return (
    <>
      <Titulo textoTitulo="Selecciona la clínica en la que quieres solicitar tu cita"></Titulo>
      <Container className="flex-grow-1 d-flex align-items-center justify-content-center pb-4  px-2">
        <Row className="w-100 justify-content-center">
          {resListaSedes.map((sede, index) => (
            <Col xs={12} sm={12} md={6} lg={4} key={`sd-${index}`}>
              <Card
                className="mb-4 shadow-sm card-resaltada"
                id={sede.idSede}
                key={sede.idSede}
                onClick={() => handleChangeIdSede(sede.idSede)}
                style={{ cursor: "pointer" }}
                onMouseEnter={() => handleMouseEnter(sede.idSede)}
                onMouseLeave={() => handleMouseLeave(sede.idSede)}
                border={idSedeHover === sede.idSede ? "primary" : ""}
              >
                <Card.Img variant="top" src={sede.foto} />
                <Card.Body>
                  <Card.Title className="pb-3">{sede.descripcion}</Card.Title>
                  <Row className="align-items-start g-1 text-muted">
                    <Col xs="auto">
                      <i className="bi bi-geo-alt-fill me-2 text-secondary pe-1"></i>
                    </Col>
                    <Col>
                      {/*    <a
                          href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                            sede.arrayLineasDireccion
                          )}`}
                          target="_blank"
                          title="Ver dirección el Google Maps"
                          rel="noopener noreferrer"
                          className="text-decoration-none"
                          onClick={(e) => e.stopPropagation()}
                        > */}
                      {sede.arrayLineasDireccion.map(
                        (lineaDireccion, index) => (
                          <span key={`ld-${index}`}>
                            {lineaDireccion}
                            {index < sede.arrayLineasDireccion.length - 1 && (
                              <br />
                            )}
                          </span>
                        )
                      )}
                      {/*  </a> */}
                    </Col>
                  </Row>

                  {sede.emailContacto ? (
                    <Row className="align-items-start pt-3 g-1 text-muted">
                      <Col xs="auto">
                        <i className="bi bi-envelope-fill me-2 text-secondary pe-1"></i>
                      </Col>
                      <Col>
                        {/* <a
                            href={`mailto:${sede.emailContacto}`}
                            title="Escríbenos un correo"
                            className="text-decoration-none"
                            onClick={(e) => e.stopPropagation()}
                          >*/}
                        {sede.emailContacto}
                        {/* </a>*/}
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                  {sede.telefono1 || sede.telefono2 ? (
                    <Row className="align-items-start pt-3 g-1 text-muted">
                      <Col xs="auto">
                        <i className="bi bi-telephone-fill me-2 text-secondary pe-1"></i>
                      </Col>
                      <Col>
                        {/* {sede.telefono1 ? (<a
                              href={`tel:${sede.telefono1}`}
                              title={`LLámanos al ${sede.telefono1}`}
                              className="text-decoration-none"
                              onClick={(e) => e.stopPropagation()}
                            > )*/}
                        {sede.telefono1}

                        {sede.telefono1 && sede.telefono2 ? (
                          <>&nbsp;/&nbsp;</>
                        ) : (
                          ""
                        )}
                        {/*{sede.telefono2 ? 
                           <a
                              href={`tel:${sede.telefono2}`}
                              title={`LLámanos al ${sede.telefono2}`}
                              className="text-decoration-none"
                              onClick={(e) => e.stopPropagation()}
                            >*/}
                        {sede.telefono2}
                      </Col>
                    </Row>
                  ) : (
                    ""
                  )}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </>
  );
};
export default ListaSedes;
